import { empApi } from "./client";

// Hiệu suất chuyên cần theo tháng -> { totalWorkingDayRate, expectedWorkRate, percent, promotionBar }
// date: MM-YYYY
export const getMyAttendanceRateByMonthApi = (date) =>
  empApi.get("/employee/app/getMyAttendanceRateByMonth", date ? { date } : undefined);

// Đánh giá KPI cá nhân theo tháng -> { evaluationStatus, consultCount, leadCount, transactionCount }
// date: MM-YYYY
export const getMyEvaluationSummaryByMonthApi = (date) =>
  empApi.get(
    "/document/api/v2/msh/evaluations/sale-kpis/monthly/summary",
    date ? { date } : undefined
  );
